import { createStore } from "vuex";

const findProductInCart = (cart, productTypeID) => {
  return cart.find(
    (cartItem) => cartItem?.productType?.producttype_id == productTypeID
  );
};

const findIndexProductInCart = (cart, productTypeID) => {
  return cart
    .map((cartItem) => cartItem.productType.producttype_id)
    .indexOf(productTypeID);
};

// Create a new store instance.
const store = createStore({
  state() {
    return {
      guestToken: null,
      product: null,
      cart: [],
      step: 1,
      user: {
        email: null,
        retype_email: null,
        phone: ["62", ""],
        full_name: null,
        identity_card: null,
      },
      user_race: {
        contact: {
          full_name: null,
          email: null,
          phone: null,
          address: null,
          province: null,
          city: null,
          region: null,
        },
        participants: {
          first_name: null,
          last_name: null,
          bib_name: null,
          identity_card: null,
          blood_type: null,
          gender: null,
          date_of_birth: null,
          size_shirt: null,
          medical_condition: null,
          is_checkup: null,
        },
        emergency: {
          full_name: null,
          phone: null,
          relation: null,
        },
        agreement: null,
      },
      validState: false,
      selectedPaymentMethod: null,
      formCount: 0,
      formStep: null,
      loadingForm: true,
      requiredForm: undefined,
      requiredInput: false,
      orderStatus: null,
      paymentStatus: "",
      transactionId: "",
      isFree: false,
      voucherCode: "",
      discount: 0,
      voucher: null,
      appId: null,
      appSetting: null,
      integrator: [],
      paymentMethodsIntegrator: [],
    };
  },
  mutations: {
    addProductToCart(state, payload = { productType: null, qty: 0 }) {
      const findType = findProductInCart(
        state.cart,
        payload?.productType.producttype_id
      );
      if (findType) {
        findType.qty++;
      } else {
        state.cart.push(payload);
      }
    },
    reduceProductFromCart(state, payload = { productType: null, qty: 0 }) {
      const findIndex = findIndexProductInCart(
        state.cart,
        payload.productType.producttype_id
      );

      if (state.cart[findIndex].qty > 1) {
        state.cart[findIndex].qty--;
      } else {
        state.cart.splice(findIndex, 1);
      }
    },
    removeProductFromCart(state, payload = { productType: null }) {
      const findIndex = findIndexProductInCart(
        state.cart,
        payload.productType.producttype_id
      );

      if (findIndex != -1) {
        state.cart.splice(findIndex, 1);
      }
    },
    nextStep(state) {
      state.step++;
    },
    backStep(state) {
      state.step--;
    },
    backToStepOne(state) {
      state.step = 1;
    },
    addUserRaceContactInformation(
      state,
      payload = {
        full_name: null,
        email: null,
        phone: null,
        address: null,
        province: null,
        city: null,
        region: null,
      }
    ) {
      state.user_race.contact.full_name = payload.full_name;
      state.user_race.contact.email = payload.email;
      state.user_race.contact.phone = payload.phone;
      state.user_race.contact.address = payload.address;
      state.user_race.contact.province = payload.province;
      state.user_race.contact.city = payload.city;
      state.user_race.contact.region = payload.region;
    },
    addUserRaceParticipantsInformation(
      state,
      payload = {
        first_name: null,
        last_name: null,
        bib_name: null,
        identity_card: null,
        blood_type: null,
        gender: null,
        date_of_birth: null,
        size_shirt: null,
        medical_condition: null,
        is_checkup: null,
      }
    ) {
      state.user_race.participants.first_name = payload.first_name;
      state.user_race.participants.last_name = payload.last_name;
      state.user_race.participants.bib_name = payload.bib_name;
      state.user_race.participants.identity_card = payload.identity_card;
      state.user_race.participants.blood_type = payload.blood_type;
      state.user_race.participants.gender = payload.gender;
      state.user_race.participants.date_of_birth = payload.date_of_birth;
      state.user_race.participants.size_shirt = payload.size_shirt;
      state.user_race.participants.medical_condition =
        payload.medical_condition;
      state.user_race.participants.is_checkup = payload.is_checkup;
    },
    addUserRaceEmergencyInformation(
      state,
      payload = {
        full_name: null,
        phone: null,
        relation: null,
      }
    ) {
      state.user_race.emergency.full_name = payload.full_name;
      state.user_race.emergency.phone = payload.phone;
      state.user_race.emergency.relation = payload.relation;
    },
    addUserInformation(
      state,
      payload = {
        email: null,
        retype_email: null,
        phone: null,
        full_name: null,
        identity_card: null,
      }
    ) {
      state.user.full_name = payload.full_name;
      state.user.email = payload.email;
      state.user.retype_email = payload.retype_email;
      state.user.phone = payload.phone;
      state.user.identity_card = payload.identity_card;
    },
    addUserRaceContactConfirmation(
      state,
      payload = {
        full_name: null,
        email: null,
      }
    ) {
      state.user_race.contact.full_name = payload.full_name;
      state.user_race.contact.email = payload.email;
    },
    addUserRaceParticipantsConfirmation(
      state,
      payload = {
        first_name: null,
        last_name: null,
        bib_name: null,
      }
    ) {
      state.user_race.participants.first_name = payload.first_name;
      state.user_race.participants.last_name = payload.last_name;
      state.user_race.participants.bib_name = payload.bib_name;
    },
    addUserRaceEmergencyConfirmation(
      state,
      payload = {
        full_name: null,
        phone: null,
        relation: null,
      }
    ) {
      state.user_race.emergency.full_name = payload.full_name;
      state.user_race.emergency.phone = payload.phone;
      state.user_race.emergency.relation = payload.relation;
    },
    changeValidation(state, validation) {
      state.validState = validation;
    },
    setPaymentMethod(state, paymentMethod) {
      state.selectedPaymentMethod = paymentMethod;
    },
  },
  getters: {
    totalCartQty(state) {
      return state.cart
        .map((cartItem) => cartItem.qty)
        .reduce((partialSum, a) => partialSum + a, 0);
    },
    totalCartPrice(state) {
      return state.cart
        .map((cartItem) => {
          const total =
            cartItem.qty *
            (cartItem.productType.discounted_price !== null &&
            cartItem.productType.discounted_price >= 0
              ? cartItem.productType.discounted_price
              : cartItem.productType.producttype_price);
          const discount =
            state.discount &&
            state.voucher?.producttype_id == cartItem.productType.producttype_id
              ? state.discount
              : 0;
          return total - discount;
        })
        .reduce((partialSum, a) => partialSum + a, 0);
    },
    findProductInCart: (state) => (productTypeID) => {
      return findProductInCart(state.cart, productTypeID);
    },
    sortedCartByTypeID(state) {
      const cart = state.cart;
      const sorted = [...cart].sort((a, b) => {
        return a.productType.producttype_id - b.productType.producttype_id;
      });
      return sorted;
    },
    valid(state) {
      return state.validState;
    },
    selectedPaymentMethod(state) {
      return state.selectedPaymentMethod;
    },
  },
});

export default store;
